'use client';

import Cookies from 'js-cookie';
import {
  createContext,
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  useContext,
  useState,
} from 'react';

interface SidebarContextType {
  isCollapsed: boolean;
  setIsCollapsed: Dispatch<SetStateAction<boolean>>;
}

export const SIDEBAR_COOKIE_NAME = 'sidebar-collapsed';

const SidebarContext = createContext<SidebarContextType>({
  isCollapsed: false,
  setIsCollapsed: () => undefined,
});

interface SidebarProviderProps {
  defaultValues?: {
    isCollapsed: boolean;
  };
}

export const SidebarProvider = ({ children }: PropsWithChildren<SidebarProviderProps>) => {
  const sidebarCollapsed = Cookies.get(SIDEBAR_COOKIE_NAME);

  const [isCollapsed, setIsCollapsed] = useState(sidebarCollapsed === 'true' || false);

  return (
    <SidebarContext.Provider
      value={{
        setIsCollapsed,
        isCollapsed,
      }}
    >
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebar = () => useContext(SidebarContext);
